import styled from 'styled-components';

import { getButtonStyle } from '@/components/AdvertisePayments/components/Footer/Footer.helpers';
import { ButtonProps } from '@/components/AdvertisePayments/components/Footer/Footer.types';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexCenterAligned, flexColumn } from '@/styles/common';

export const FooterWrapper = styled.div<{ $isSticky?: boolean }>`
  width: 100%;
  ${flexCenterAligned};
  min-height: 84px;
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--bg-card);
  padding-inline: 40px;
  padding-bottom: 20px;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    min-height: 89px;
    align-items: start;
    padding: 10px 30px env(safe-area-inset-bottom);
    background-color: transparent;
    position: fixed;
  }
`;

export const ContentColumn = styled.div`
  ${flexColumn};
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const ActionButton = styled(Typography)
  .withConfig({
    shouldForwardProp: property =>
      !['$type', '$isDark', '$isLoading', '$variant'].includes(property)
  })
  .attrs({
    variant: 'title4'
  })<ButtonProps>`
  ${flexCenterAligned};
  width: 100%;
  min-height: 44px;
  border-radius: 28px;
  border: none;
  font-weight: 500;
  font-size: 15px;
  transition: background 0.3s ease, opacity 0.3s ease;
  background: var(--system-blue);
  opacity: ${({ $isLoading }) => ($isLoading ? 0.5 : 1)};
  cursor: ${({ $isLoading }) => ($isLoading ? 'wait' : 'pointer')};

  &:disabled {
    opacity:.5;
    cursor:not-allowed;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    max-width: 100%;

    background: ${({ $type, $isDark }) =>
      getButtonStyle($type, $isDark).background};
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    background: var(--system-blue);
  };

  &:hover {
    background: var(--system-deepBlue);
  }

`;

export const ActionButtonLabel = styled(Typography)
  .withConfig({
    shouldForwardProp: property =>
      !['$type', '$isDark', '$variant'].includes(property)
  })
  .attrs<ButtonProps>({
    variant: 'title4'
  })`
  color: ${({ $type, $isDark }) => getButtonStyle($type, $isDark).labelColor};

  @media (max-width: ${BREAKPOINTS.tablet}) {
    color: ${({ $type, $isDark }) =>
      getButtonStyle($type, $isDark).labelColorTablet};
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    color: ${({ $type, $isDark }) => getButtonStyle($type, $isDark).labelColor};
  }
`;

export const AgreementText = styled(Typography).attrs({
  variant: 'body5'
})`
  width: 100%;
  text-align: center;
  text-align-last: center;
  color: var(--textAndLabels-tertiary);
  hyphens: auto;
  overflow-wrap: break-word;
  word-break: break-word;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding: 0 0 15px 0;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding-inline: 16px;
  }
`;

export const AgreementLink = styled(Typography).attrs({
  variant: 'body5'
})`
  display: inline-block;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  color: inherit;
  cursor: pointer;
`;

export const SpinnerWrapper = styled.div`
  ${flexCenterAligned};
`;

export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid var(--system-white);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
